

import request from '@/utils/request'

export function fetchCombineCombines() {
  return request({
    baseURL: process.env.REACT_APP_BASE_API_STOCK,
    url: '/combine/race/user/combines',
    method: 'post'
  })
}

export function fetchCombineRegister(data) {

  return request({
    baseURL: process.env.REACT_APP_BASE_API_STOCK,
    url: '/combine/race/user/register',
    data: data,
    method: 'post'
  })
}


export function fetchCombineStatus() {
  
  return request({
    baseURL: process.env.REACT_APP_BASE_API_STOCK,
    url: '/combine/race/user/status',
    method: 'post'
  })
}


/**
 * 组合比赛
 * 周列表
 */
export function getMatchWeekList( query) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/week-term/all`,
    method: 'get',
    params: query
  })
}



/**
 * 组合比赛
 * 我邀请的好友最新排名明细
 */
export function getInvitationRank( activityId) {
  return request({
    baseURL: '/chaos/api',
    url: `/v1/match/my/invitation-rank/detail/${activityId}`,
    method: 'post',
    // data: data
  })
}









// WEBPACK FOOTER //
// ./src/api/combine.js